import { render, staticRenderFns } from "./TrainingsList.vue?vue&type=template&id=cb1229d4&scoped=true"
import script from "./TrainingsList.vue?vue&type=script&lang=js"
export * from "./TrainingsList.vue?vue&type=script&lang=js"
import style0 from "./TrainingsList.vue?vue&type=style&index=0&id=cb1229d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1229d4",
  null
  
)

export default component.exports